import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/elementor': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M425.6 32c12.4 0 22.4 10 22.4 22.4v403.2c0 12.4-10 22.4-22.4 22.4h-403.2c-12.4 0-22.4-10-22.4-22.4v-403.2c0-12.4 10-22.4 22.4-22.4h403.2zM164.3 355.5v-199h-39.8v199h39.8zM323.6 355.5v-39.8h-119.5v39.8h119.5zM323.6 275.9v-39.8h-119.5v39.8h119.5zM323.6 196.2v-39.8h-119.5v39.8h119.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/elementor.js
// module id = 806
// module chunks = 0